const CookieStorage = {
	get(key: string): string | null {
		return getCookie(key);
	},

	set(key: string, value: string, expiresIn: number) {
		document.cookie = `${key}=${value};max-age=${expiresIn};SameSite=Strict;path=/;`;
	},

	delete(key: string) {
		document.cookie = `${key}=;max-age=0;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
	},
};

const getCookie = (cname: string) => {
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
};

export default CookieStorage;
